import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { ExternalNaptarPage } from './external-naptar.page';

const routes: Routes = [
  {
    path: '',
    component: ExternalNaptarPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [ExternalNaptarPage]
})
export class ExternalNaptarPageModule {}
